import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutSection() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation();
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation();

  const stats = [
    { value: '2', label: 'Flagship products' },
  ];

  return (
    <section id="about" className="py-28 bg-[#F5F3EE]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div
          ref={leftRef}
          className={`animate-fade-up mb-16 ${leftVisible ? 'visible' : ''}`}
        >
          <span className="text-[#C74B1C] text-sm font-semibold tracking-[0.2em] uppercase">
            Who We Are
          </span>
          <h2
            className="mt-3 font-extrabold leading-tight text-[#0D0D0D]"
            style={{ fontFamily: 'Syne, sans-serif', fontSize: 'clamp(2rem, 4vw, 3.2rem)' }}
          >
            A Dedicated Team of
            <br />
            iOS Development Experts
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Image */}
          <div
            ref={leftRef}
            className={`animate-slide-left ${leftVisible ? 'visible' : ''}`}
          >
            <div className="relative w-full h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a53e5e50be65ecdf1df293faa106c793.jpg"
                alt="KROKO d.o.o. iOS development team at work"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#0D0D0D]/30 to-transparent" />
            </div>
          </div>

          {/* Text */}
          <div
            ref={rightRef}
            className={`animate-slide-right ${rightVisible ? 'visible' : ''}`}
          >
            <p className="text-[#4A4A4A] text-base leading-relaxed mb-6">
              Founded on a passion for clean, secure, and high-performance mobile software,
              <strong className="text-[#0D0D0D]"> KROKO d.o.o.</strong> brings together
              seasoned iOS engineers, UX designers, and security specialists who share
              one mission: to make mobile life simpler and safer.
            </p>
            <p className="text-[#4A4A4A] text-base leading-relaxed mb-10">
              From our base in Visoko, Bosnia and Herzegovina, we develop applications that
              reach users globally. Every product we ship is tested rigorously, designed
              thoughtfully, and built with the latest iOS frameworks to ensure outstanding
              reliability and performance.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="border-l-2 border-[#C74B1C] pl-4"
                >
                  <div
                    className="font-extrabold text-[#0D0D0D] text-3xl"
                    style={{ fontFamily: 'Syne, sans-serif' }}
                  >
                    {stat.value}
                  </div>
                  <div className="text-[#6B6B6B] text-xs mt-1 leading-snug">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
